<template>
  <nav id="sidebar" class="sidebar-wrapper">
    <div class="sidebar-content d-flex flex-column">
      <div class="sidebar-brand">
        <a href="/">Annotator</a>
        <div id="minimize-sidebar" class="ml-3" style="cursor:pointer">
          <i class="fas fa-angle-left"></i>
          <i class="fas fa-thumbtack d-none"></i>
        </div>
      </div>
      <!-- sidebar-header  -->
      <div class="sidebar-item sidebar-search">
		<div class="input-group">
      	  <a href="/search" style="width: 100%">
      	  	<button type="button" class="btn mb-0" style="width: 100%" :class="{'btn-secondary' : user.is_admin, 'btn-light' : !user.is_admin}">
	        	<i class="fas fa-search mr-1" style="vertical-align: middle; color: inherit;"></i>
				<div style="display: inline-block; vertical-align: middle;">{{ __('translations.button.search') }}</div>
	        </button>
      	  </a>
		</div>
      </div>
      
      <div class="sidebar-item sidebar-menu flex-grow-1">
        <ul>
          <li class="header-menu">
            <span>{{__('translations.menu.settings')}}</span>
          </li>
          <li style="padding: 8px 30px 8px 20px;">
          	<!-- Preview annotations -->
		 	<div class="custom-control custom-switch">
			  <input type="checkbox" class="custom-control-input" id="previewAnnotationSwitch" :checked="previewAnnotations" @click="togglePreviewAnnotations($event)" />
			  <label class="custom-control-label" for="previewAnnotationSwitch"><span class="custom-control-label-text">{{ __('translations.menu.preview_annotations') }}</span></label>
			</div>
          </li>
          <li v-if="user.is_admin">
          	<router-link :to="{name: 'dashboard'}">
                <i class="fa fa-tachometer-alt"></i>
                <span class="menu-text">{{ __('translations.title.dashboard') }}</span>
            </router-link>
            <router-link :to="{name: 'import'}">
                <i class="fas fa-file-import"></i>
                <span class="menu-text">{{ __('translations.menu.import') }}</span>
            </router-link>
          </li>
          <li class="sidebar-dropdown">
          	<a href="#">
	          	<i class="fas fa-box-open"></i>
	            <span class="menu-text">{{ __('translations.menu.file_explorer') }}</span>
            </a>
            <div class="sidebar-submenu">
              <ul>
              	<li>
		          	<router-link :to="{name: 'all-documents', query: {page: 1, sortBy: 'id', sort: 'ASC'}}">
		                {{ __('translations.menu.all_documents') }}
		            </router-link>
	            </li>
	            <li>
		          	<router-link :to="{name: 'my-documents', query: {page: 1, sortBy: 'id', sort: 'ASC'}}">
		                {{ __('translations.menu.my_documents') }}
		            </router-link>
	            </li>
              </ul>
            </div>
          </li>
        </ul>
        <ul v-if="collections.length > 0">
          <li class="header-menu">
            <span>{{__('translations.menu.my_documents')}}</span>
          </li>
          <li class="sidebar-dropdown" v-for="collection in collections" :key="'collection-' + collection.id">
          	<a href="#" @click="expandCollection($event)">
              <i class="fas fa-folder"></i>
              <span class="menu-text">{{collection.label}}</span>
              <span class="badge badge-pill badge-info">{{collection.manifests.length}}</span>
            </a>
            <div class="sidebar-submenu" v-if="collection.manifests.length > 0">
              <ul>
                <li v-for="manifest in collection.manifests" :id="'manifest-' + manifest.id" :key="'manifest-' + manifest.id">
                  <router-link :to="{name: 'canvases', params: {cId: collection.id, mId: manifest.id}}">
                  	<span class="menu-text">{{manifest.label}}</span>
                  	<span size="18" class="sidebar-badge badge badge-info">{{manifest.canvases.length}}</span>
                  </router-link>
                </li>
              </ul>
             </div>
          </li>
        </ul>
      </div>
      <!-- sidebar-menu  -->
    </div>
	<!-- sidebar-content  -->
    <div class="sidebar-footer">
      <div><a href="/about"><i class="fas fa-info-circle"></i></a></div>
      <div><a href="/user/profile"><i class="fas fa-user"></i></a></div>
      <div><span @click="logout"><i class="fa fa-power-off"></i></span></div>
      <div class="pinned-footer"><a href="#"><i class="fas fa-ellipsis-h"></i></a></div>
    </div>
  </nav>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
	data: () => ({
		csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
	}),
	props: ['user', 'redirect'],
	computed: {
		...mapGetters([
			'previewAnnotations', 'collections'
		])
	},
	created() {
		this.fetchUserCanvases();
	},
	mounted() {
		Echo.channel('user-manifest-' + this.user.id).listen('UserManifestEvent', (e) => {
			this.fetchUserCanvases();
		});
		
		if(this.$route.path !== this.redirect.path && this.redirect.path !== '/') {
			this.$router.push(this.redirect);
		}
	},
	methods: {
		fetchUserCanvases() {
			this.$store.dispatch('FETCH_USER_MANIFESTS').then(() => {
				if($('.router-link-active').length) {
					$('.router-link-active').parents('.sidebar-dropdown').addClass('active');
					$('.router-link-active').parents('.sidebar-submenu').show();
				}
				
				var $element = $('#manifest-' + this.$route.params.mId)
				this.scrollIntoView($element);
			});
		},
		expandCollection($event) {
			var element = $event.target;
			
			$('.sidebar-submenu').hide();
			if ($(element).parents('li').hasClass('active')) {
				$('.sidebar-dropdown').removeClass('active');
				$(element).parents('li').removeClass('active');
			} else {
				$('.sidebar-dropdown').removeClass('active');
				$(element).parents('li').find('.sidebar-submenu').show();
				$(element).parents('li').addClass('active');
				
				// Bring the parent menu to the view.
				var elementOffsetTop = $(element).offset().top;
				var elementHeight = $(element).height();
				var sidebarHeight = $('.sidebar-content').height();
				var offset = (elementHeight < sidebarHeight) ? elementOffsetTop - ((sidebarHeight / 2) - (elementHeight / 2)) : elementOffsetTop;
				
				$('.sidebar-menu').animate({
				    scrollTop: offset
				}, 200);
			}
		},
		logout() {
			axios.post('/logout').then(function (response) {
				if (response.status === 302 || 401) {
					document.location.href = '/login';
				} else {
					// throw error and go to catch block
				}
			}).catch(error => {
				consol.log('Couldn\'t log out!');
			});
		},
		scrollIntoView($element) {
			if(typeof $element !== 'undefined' && $element.length) {
				var $sidebarDropdown = $element.parents('.sidebar-dropdown');	
				if($sidebarDropdown.length) {
					$sidebarDropdown.addClass('active');
					$sidebarDropdown.find('div.sidebar-submenu').slideDown(200);
				}
				
				var elementOffsetTop = $element.offset().top;
				var elementHeight = $element.height();
				var sidebarHeight = $('.sidebar-content').height();
				var offset = (elementHeight < sidebarHeight) ? elementOffsetTop - ((sidebarHeight / 2) - (elementHeight / 2)) : elementOffsetTop;
				
				$('.sidebar-menu').animate({
				    scrollTop: offset
				}, 500);
			}
		},
		togglePreviewAnnotations(event) {
			this.$store.commit('SET_PREVIEW_ANNOTATIONS', event.target.checked);
		}
	},
}
</script>